import { ElementRef, Component, Output, EventEmitter, ViewChild, AfterViewInit, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
	selector: 'app-electric-signature',
	templateUrl: './electric-signature.component.html',
	styleUrls: ['./electric-signature.component.scss']
})

export class ElectricSignatureComponent implements AfterViewInit, OnInit, OnChanges{
  @ViewChild('signaturePad') signPadRef: ElementRef;
  @Output() signatureEmit = new EventEmitter<any>();
  @Input() scrollable = true; //stops scrolling on body
  @Input() signatureBase64:any = false; //reload canvas from base64 img
  @Input() canvasHeight:any = 125;
  context: any = false; //canvas
  pos: any = false; //mouse position
  signing = false; //mousedown = true

  constructor(){
  	this.pos = { x: 0, y: 0 };
  }
  
  
  ngOnChanges(changes: SimpleChanges): void {
  	if(changes.scrollable){
  		changes.scrollable.currentValue ? this.enableScroll() : this.disableScroll()
  	}
    
  	if(changes.signatureBase64){
  		setTimeout(() => {this.getCanvas()}, 1000)
  	}
  }
  
  ngOnInit(): void {
  	//Need this to keep canvas bounds in sync on resize
  	window.addEventListener('resize', () => {
  		setTimeout(() => {
  			this.getCanvas()
  		}, 1000)
  	});
  }
  
  ngAfterViewInit(): void {
  	//height for canvas - default to 125;
  	this.signPadRef.nativeElement.height = this.canvasHeight;
  	//need this otherwise bounds are incorrect
  	setTimeout(() => {
  		this.getCanvas()
  	}, 1000);
  }

  getCanvas(){
  	if(!this.scrollable){this.disableScroll()}
  	const w = this.signPadRef.nativeElement.width = this.signPadRef.nativeElement.offsetWidth
  	const h = this.signPadRef.nativeElement.height = this.signPadRef.nativeElement.offsetHeight
  	this.context = this.signPadRef.nativeElement.getContext('2d');

  	if(this.signatureBase64){
  		const signature = new Image(w, h);
  		signature.onload = (() => {
  			this.context.drawImage(signature, 0, 0);
  		}).bind(this);

  		signature.src = this.signatureBase64;
  	}else{
  		this.drawGuideLine();
  	}
  }

  
  draw(event){
  	if(this.signing){
  		this.context.lineWidth = 4;
  		this.context.linecap = 'round';
  		this.context.strokeStyle = '#ff1e1e';
  		this.context.beginPath();
  		this.context.moveTo(this.pos.x, this.pos.y);
  		this.setPosition(event);
  		this.context.lineTo(this.pos.x, this.pos.y)
  		this.context.stroke();
  	}
  }

  setPosition(event: any){
  	const canvas_pos = this.signPadRef.nativeElement.getBoundingClientRect(); 
  	this.pos.x =  event.clientX - canvas_pos.left;
  	this.pos.y =  event.clientY - canvas_pos.top
  }

  drawmode(active){
  	active ? this.disableScroll() : this.enableScroll();
  	this.signing = active;
  }

  clear(){
  	this.context.clearRect(0, 0, this.signPadRef.nativeElement.width, this.signPadRef.nativeElement.height);
  	this.drawGuideLine();
  }

  captureCanvas(cancel:any = false){
  	!cancel ? this.signatureEmit.emit(this.rasterizeCanvas()) : this.signatureEmit.emit(false);
  	this.clear();
  }

  rasterizeCanvas(){
  	const ref = this.signPadRef.nativeElement as HTMLCanvasElement;
  	return ref.toDataURL('image/png', 100);
  }

  drawGuideLine(){
  	const w = this.signPadRef.nativeElement.width
  	const h = this.signPadRef.nativeElement.height
  	//dotted line
  	const start = { x: (w * .02), y: h-25 }
  	const end = { x: (w - start.x), y: h-25 }
  	this.context.lineWidth = 1;
  	this.context.strokeStyle = 'gray';
  	this.context.setLineDash([2, 6]);
  	this.context.lineDashOffset = 4;
  	this.context.beginPath();
  	this.context.moveTo(start.x, start.y);
  	this.context.lineTo(end.x, end.y)
  	this.context.stroke();
  	this.context.setLineDash([0,0])
  	//sign here x
  	const x1_start = { x:start.x + 12, y: start.y-5 }
  	const x1_end =   { x:start.x, y: x1_start.y-12 }
  	const x2_start = { x:start.x, y: start.y-5 }
  	const x2_end =   { x:start.x + 12, y: x1_start.y-12 }
  	this.context.lineWidth = 1;
  	this.context.linecap = 'round';
  	this.context.strokeStyle = '#343434';
  	this.context.beginPath();
  	this.context.moveTo(x1_start.x, x1_start.y)
  	this.context.lineTo(x1_end.x, x1_end.y)
  	this.context.stroke();
  	this.context.beginPath();
  	this.context.moveTo(x2_start.x, x2_start.y)
  	this.context.lineTo(x2_end.x, x2_end.y)
  	this.context.stroke();

   
  }

  preventDefault(e) {
  	e.preventDefault();
  }

  disableScroll() {
  	this.scrollable = false;
  	document.body.addEventListener('touchmove', this.preventDefault, { passive: false });
  }

  enableScroll() {
  	this.scrollable = true;
  	document.body.removeEventListener('touchmove', this.preventDefault);
  }


}
